import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequirePermission } from "@/components/universal/require-permission";
import NotFoundPage from "@/catchall";

export const Route = createFileRoute("/_private/_inventory-360")({
  component: InventoryLayout,
});

function InventoryLayout() {
  return (
    <RequirePermission permission="inventory_360" fallback={<NotFoundPage />}>
      <Outlet />
    </RequirePermission>
  );
}
